module.exports = __webpack_public_path__ + "assets/img/pfive.620ab10e.png";